import intl from 'react-intl-universal'

export default {
  type: 'image',
  title: `Image`,
  icon: `picture-o`,
  interfaceApi: '/photo/selector/?select=multiple',
  template: `<figure class="feature-wrapper" contenteditable="false" data-testid="ng-photo-container">
               <img  contenteditable="false" src="{{feature.additional_properties.proxyUrl || feature.url}}" alt="{{feature.subtitle}}">
               <div data-update-text="true"  contenteditable="false" class="info-bar py-3" data-testid="ng-photo-info-bar">
                 <i class="fa fa-picture-o"></i><strong>${intl.get(
                   'blocks.image.cardSubtitle'
                 )}</strong> &quot;{{feature.subtitle || feature.additional_properties.originalName || '${intl
    .get('blocks.image.unknown')
    .toString()}'}}&quot;
                 <span ng-show="!feature.additional_properties.published" class="ng-hide pull-right unpublished"><i class="fa fa-exclamation-triangle" aria-hidden="true"></i> ${intl.get(
                   'blocks.image.unpublishedBadge'
                 )}</span>

                 <span ng-show="feature.additional_properties.published" class="ng-hide pull-right published">${intl.get(
                   'blocks.image.publishedBadge'
                 )}</span>

                 <div ng-if="feature.caption">
                   <strong>${intl.get(
                     'blocks.image.caption'
                   )}:</strong> {{feature.caption}}
                 </div>

                 <div ng-if="feature.additional_properties.link">
                   <a href="{{feature.additional_properties.link}}" target="_blank">${intl.get(
                     'blocks.image.linkLabel'
                   )}</a>
                 </div>
                 <div class="pt-2" contenteditable="false" ng-if="feature.additional_properties.usage_instructions">
                   <p class="text-danger">
                     <strong>${intl.get(
                       'blocks.image.instructions'
                     )}:</strong> {{feature.additional_properties.usage_instructions}}
                   </p>
                 </div>
                 <div class="mt-1">
                   <button type="button" class="btn btn-primary btn-sm" ng-click="showPropModal(index)" title=${intl.get(
                     'blocks.image.buttons.edit'
                   )}>${intl.get('blocks.image.buttons.edit')}</button>
                 </div>
               </div>
             </figure>`,
  propertyTemplate: `
      <div class="form-group row" ng-if="$root.globalSettingsModel.mediaOptions.image.showCaption">
        <label>Caption</label>
        <textarea
          rows="10"
          class="form-control"
          smart-quote-handler
          ng-model="feature.caption"
          ng-change="feature.referent_properties.caption = feature.caption"></textarea>
      </div>
      <div class="form-group row" ng-if="$root.globalSettingsModel.mediaOptions.image.showSubtitle">
        <label>Subtitle</label>
        <textarea
          smart-quote-handler
          rows="5"
          class="form-control"
          ng-model="feature.subtitle"
          ng-change="feature.referent_properties.subtitle = feature.subtitle"></textarea>
      </div>
      <div class="form-group row" ng-if="$root.globalSettingsModel.mediaOptions.image.showLink">
        <label>Link URL</label>
        <input
          type="text"
          class="form-control"
          ng-model="feature.additional_properties.link">
      </div>
      <div class="row" ng-if="$root.globalSettingsModel.mediaOptions.noImageFields">
        <p>No fields to edit, see 'Media Options' in settings to configure</p>
      </div>
      <div class="pt-2" contenteditable="false" ng-if="feature.additional_properties.usage_instructions">
        <p class="text-danger">
          <strong>Usage Instructions:</strong> {{feature.additional_properties.usage_instructions}}
        </p>
      </div>
    `,
  preview: function (feature) {
    const imageId = feature._id
    if (imageId) {
      window.open('/photo/' + imageId)
    }
  },
  customHandleButtons: [
    {
      className: 'fa fa-bullseye',
      event: 'set-focal-point',
      tooltip: 'Set focal point',
    },
  ],
  beforeSave: function (ansObj) {
    if (!ansObj.additional_properties.link) {
      return
    }

    const httpRegex = /^http(s?):\/\//
    const match = httpRegex.exec(ansObj.additional_properties.link)

    if (!match) {
      ansObj.additional_properties.link =
        '//' + ansObj.additional_properties.link.replace(/^\/+/, '')
    }
  },
  // onPaste : function(elem) {
  /* TODO FIGURE THIS OUT! */
  //    return {
  //    };
  // }
}
